export default __webpack_public_path__ + "static/media/E10.aadecaa5.mp3";